import { ReactElement } from 'react';
import { Checkbox, Pagination, styled } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { showExpDate } from '.';
import {
  CsaRawData,
  DeaNumFunction,
  DeaPageFunction,
  EditMode,
  parseDate,
  ValueLabel,
  variables,
} from '../common';
import { path, pathOr } from 'rambda';
import { map as lmap, compose as lcompose } from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const renderStack = (properties: ValueLabel<keyof CsaRawData>[]) =>
  lcompose(
    fold(
      () => <article>Empty</article>,

      ({ as, totalPages, size, searchByPage, selectedDeaNums, save }) => (
        <Wrapper>
          {lmap<CsaRawData, ReactElement>(a => (
            <ItemWrapper key={a.deaNumber}>
              {lmap<ValueLabel<keyof CsaRawData>, ReactElement>(
                ({ value, label }) => (
                  <Line key={value}>
                    <Label>{label}:</Label>

                    <span>
                      {value === 'expirationDate'
                        ? showExpDate(a)
                        : path<string>(value)(a)}
                    </span>
                  </Line>
                )
              )(properties)}

              <span className={''}>
                <Checkbox
                  checked={selectedDeaNums.indexOf(a.deaNumber) !== -1}
                  disabled={selectedDeaNums.indexOf(a.deaNumber) !== -1}
                  onChange={() => {
                    flow(
                      (deaNum: string) => ({
                        key: uuidv4(),
                        deaNum,
                        editMode: 'Read' as EditMode,

                        expDt: flow(
                          pathOr(null, 'expirationDate'),
                          parseDate
                        )(a),

                        msgCode: '',
                        msgText: '',
                        serialNumber: null,
                      }),
                      save
                    )(a.deaNumber);
                  }}
                  name="selectDeaNum"
                  color="primary"
                />
              </span>
            </ItemWrapper>
          ))(as)}
          <Paginatio
            count={totalPages}
            onChange={(z, page) => {
              const pageInfo = {
                pageNumber: page - 1,
                pageSize: 10,
              };
              searchByPage(pageInfo);
            }}
            shape="rounded"
          />
        </Wrapper>
      )
    ),
    ({
      as,
      totalPages,
      size,
      searchByPage,
      selectedDeaNums,
      save,
    }: {
      as: CsaRawData[];
      totalPages: number;
      size: number;
      searchByPage: DeaPageFunction;
      selectedDeaNums: string[];
      save: DeaNumFunction;
    }) =>
      as.length === 0
        ? left(void 0)
        : right({
            as,
            totalPages,
            size,
            searchByPage,
            selectedDeaNums,
            save,
          })
  );

const Wrapper = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },
}));

const ItemWrapper = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },

  paddingBottom: '0.5rem',
  borderBottom: variables.cardBorder,
}));

const Line = styled('span')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '1rem',
  },
}));

const Label = styled('span')(({ theme }) => ({ fontWeight: 700 }));
const Paginatio = styled(Pagination)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}));

// styled('article')(({ theme }) => ({}));
